import { mergeClasses, Text } from '@fluentui/react-components';
import React from 'react';
import { useNavigationTabPanelHeaderStyles } from './NavigationTabPanelHeader.styles';

interface NavigationTabPanelHeaderProps {
  icon?: React.ReactNode
  text: string
  className?: string
}

const NavigationTabPanelHeader: React.FC<NavigationTabPanelHeaderProps> = ({
  icon,
  text,
  className,
}) => {
  const styles = useNavigationTabPanelHeaderStyles();

  return (
    <div className={mergeClasses(styles.header, className)} data-testid="navigation-tab-panel-header">
      {icon && icon}
      <Text className={styles.headerText}>
        {text}
      </Text>
    </div>
  );
};

export default NavigationTabPanelHeader;
